import { getTargetAPI } from 'features/securities/utils';
import { portfolioEndpoint } from '../constants/apiEndpoint';
import { APIResponse } from '../../../../@types/api-response';
import { PortfolioResponse } from '../types/api/portfolio';
import { tradingApiInstance } from './instance/trading';

export const getPortfolio = async (): Promise<
  APIResponse<PortfolioResponse>
> => {
  const targetAPI = getTargetAPI();
  return tradingApiInstance[targetAPI].get(
    portfolioEndpoint.portfolio[targetAPI],
  );
};

export const getPortfolioDetail = (
  symbol: string,
): Promise<APIResponse<PortfolioDetailResponse>> => {
  const targetAPI = getTargetAPI();
  return tradingApiInstance[targetAPI].get(
    portfolioEndpoint.portfolioDetail[targetAPI](symbol),
  );
};
